<template>
  <div class="form-submit-file container view">
    <Card class="form-submit-file__card" :title="$metaInfo.title" variant="widget">
      <ButtonComponent tag="a" :href="link" :label="$t('downloadX', { x: '' })" :icon="['fal', 'file']" />
      <i> {{ $t('downloadManuallyAlert') }} </i>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card-v2'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  computed: {
    link() {
      const { url, name, type } = this.$route.query
      if (!url) return

      return `${url}?name=${name}&type=${type}`
    },
  },
  mounted() {
    if (this.link) window.location.href = this.link
  },
  metaInfo() {
    return {
      title: this.$t('fileDownload'),
    }
  },
  components: {
    Card,
    Alert,
  },
}
</script>

<style lang="scss">
.form-submit-file {
  &__card {
    margin-top: 5vh;
    .card-v2__content {
      display: flex;
      gap: 1rem;
      flex-direction: column;
      align-items: start;
    }
  }
}
</style>
